import { IGlossarySettings } from 'store/auth';
import { useAppSelector } from 'store/hooks';

export function useGlossaryTermVisibility() {
    const glossarySettings: IGlossarySettings | undefined = useAppSelector(
        (state) => state.auth?.configuration?.glossarySettings,
    );

    const isVisibleGlossaryTermByStatus = (term: any) => {
        if (!glossarySettings?.use_statuses || !term?.status || term?.status?.visible !== 'N') {
            return true;
        } else {
            return false;
        }
    };

    return { isVisibleGlossaryTermByStatus };
}
